import { Autocomplete, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import { CheckPermissions } from "../../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../../../features/userSlice";
interface Props {
  getSingleWebsite: any;
  editWebsiteData: any;
  handlechange: any;
  industryDetails: any;
  territoryDetails: any;
  errors: any;
}

function DetailsConnectivity({
  getSingleWebsite,
  editWebsiteData,
  handlechange,
  industryDetails,
  territoryDetails,
  errors,
}: Props) {
  //-- update state on Handle Input Change
  const handleInputChange = (name: string, value: any) => {
    handlechange(name, value);
  };
  const response = useSelector(selectUserData);
  const websiteTypes = [{ label: "SEO" }, { label: "PPC" }];
  const hasEditWebsiteURLPermission = CheckPermissions(
    response?.data?.products?.assets,
    "websites",
    "edit_website_url"
  );
  return (
    <>
      <Box>
        <Typography>Details & Connectivity</Typography>
        <Grid container columnSpacing={{ xs: 2, sm: 2, md: 2 }} mt={2} mb={2}>
          <Grid item xs={12} md={4}>
            <TextField
              id="outlined-multiline-flexible"
              label="Website Name" // Set your label here
              placeholder="How you like the site to be called" // Set your placeholder here
              required
              fullWidth
              color="secondary"
              size="small"
              error={errors.ui_site_name}
              helperText={
                errors.ui_site_name
                  ? errors.ui_site_name
                  : "minimum of 8 characters, only letters and numbers."
              }
              name={"ui_site_name"}
              value={editWebsiteData.ui_site_name}
              onChange={(e) =>
                handleInputChange("ui_site_name", e.target.value)
              }
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              id="outlined-multiline-flexible"
              label="Website URL" // Set your label here
              placeholder="How you like the site to be called" // Set your placeholder here
              required
              fullWidth
              color="secondary"
              size="small"
              value={editWebsiteData.site_url}
              onChange={(e) => handleInputChange("site_url", e.target.value)}
              disabled={!hasEditWebsiteURLPermission}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography
              sx={{ marginTop: "4px", fontSize: "12px", color: "#00000099" }}
            >
              minimum of 8 characters, only letters and numbers.
            </Typography>
          </Grid>
        </Grid>

        <Button
          variant="outlined"
          sx={{ display: "flex", alignItems: "center" }}
          color="secondary"
          disabled
        >
          Link domain
          <InsertLinkIcon sx={{ ml: 1 }} />{" "}
          {/* Adjust the spacing with margin-left */}
        </Button>
      </Box>
      <Box>
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={6} md={2}>
            <Autocomplete
              fullWidth
              options={websiteTypes.map((site: any) => ({
                label: site?.label,
              }))}
              getOptionLabel={(option: any) => option.label || ""}
              value={
                websiteTypes.find(
                  (site_type: any) =>
                    site_type.label === editWebsiteData?.site_type
                ) || null
              }
              onChange={(_, newValue: any) => {
                handleInputChange("site_type", newValue?.label || null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Website type"
                  name={"site_type"}
                  required
                  error={errors.site_type}
                  helperText={errors.site_type}
                  color="secondary"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              size="small"
              color="secondary"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Autocomplete
              fullWidth
              options={
                industryDetails.length > 0
                  ? industryDetails.map((industry: any) => ({
                      industry_name: industry?.industry_name,
                      shared_uid: industry?.shared_uid,
                    }))
                  : []
              }
              getOptionLabel={(option: any) => option.industry_name || ""}
              value={
                industryDetails?.find(
                  (industry: any) =>
                    industry.shared_uid ===
                    editWebsiteData?.industries_shared_uid
                ) || null
              }
              onChange={(_, newValue: any) => {
                handleInputChange(
                  "industries_shared_uid",
                  newValue?.shared_uid || null
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Industry"
                  color="secondary"
                  name={"industries_shared_uid"}
                  error={errors.industries_shared_uid}
                  helperText={errors.industries_shared_uid}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Autocomplete
              fullWidth
              options={
                territoryDetails.length > 0
                  ? territoryDetails.map((territory: any) => ({
                      territory_name: territory?.territory_name,
                      shared_uid: territory?.shared_uid,
                    }))
                  : []
              }
              getOptionLabel={(option: any) => option.territory_name || ""}
              value={
                territoryDetails?.find(
                  (territory: any) =>
                    territory.shared_uid ===
                    editWebsiteData?.territories_shared_uid
                ) || null
              }
              onChange={(_, newValue: any) => {
                handleInputChange(
                  "territories_shared_uid",
                  newValue?.shared_uid || null
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Territory"
                  color="secondary"
                  name={"territories_shared_uid"}
                  error={errors.territories_shared_uid}
                  helperText={errors.territories_shared_uid}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              id="outlined-multiline-flexible"
              label="Timezone" // Set your label here
              placeholder="Timezone" // Set your placeholder here
              required
              fullWidth
              color="secondary"
              size="small"
              value={getSingleWebsite.timezone}
              disabled
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>

        <Typography
          sx={{ marginTop: "16px", fontSize: "12px", color: "#00000099" }}
        >
          All fields are mandatory.
        </Typography>
      </Box>
    </>
  );
}

export default DetailsConnectivity;
